import axios from 'axios'
import { Message } from 'element-ui'

// axios.defaults.withCredentials = true

// create an axios instance
if (process.env.NODE_ENV === 'development') {
  var baseURL = 'http://wsjtoa.com:9989'
  // var baseURL = 'http://172.16.72.7:9089'

  
} else if (process.env.NODE_ENV === 'production') {
  var baseURL = 'http://wsjtoa.com:9989'
  // var baseURL = 'http://172.16.72.7:9089'



}
const service = axios.create({
  baseURL: baseURL, 
  timeout: 10000 // request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
    if (config.url.startsWith("http")) {
      config.baseURL = ''
    }
    return config
  },
  error => {
    // Do something with request error
    console.log(error) // for debug
    Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  response => {
    const res = response.data
    if (res.code === 200 || res.code === 0) {
      return response
    } else {
      Message({
        message: '后台不能连接，请联系系统管理员',
        type: 'error',
        duration: 10 * 1000
      })
      return Promise.reject(response)
    }
  }, error => {
    console.log('err' + error)// for debug
    Message({
      message: '后台不能连接，请联系系统管理员',
      type: 'error',
      duration: 10 * 1000
    })
    return Promise.reject(error)
  })

export default service
